export default function getTilesConfiguration() {
  return [
    {
      id: 'Infinity (Live)',
      title: 'Infinity',
    }
  ];
}